import React from "react";
import "../../stylesheets/_home.scss";
import "../../stylesheets/screen.css.scss";
import logo from "../../Assets/images/logo.png";
import {Link} from "react-router-dom";
import {Button} from "antd";
import ContactUs from "../ContactUs";
const NavBar = () => {
  return (
    <>
      <div className="navbar-container">
        <div className="navbar-content">
          <div className="navbar-heading">
            <Link to="/">
              <img src={logo} alt="Img"></img>
            </Link>
          </div>
          <div className="navbar-list">
            <Link to="ContactUs" className="link-button">Book a Demo</Link>
          </div>
        </div>
        <div className="navBottom"/>
      </div>
    </>


  );
};

export default NavBar;
